import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import type { ClientDetail } from "../types/clients.types";

interface ClientsTableProps {
	clients: ClientDetail[];
	onOpenClient: (client: ClientDetail) => void;
}

export function ClientsTable({ clients, onOpenClient }: ClientsTableProps) {
	// Function to helper determine color for payment progress fill
	const getProgressFillColor = (percent: number) => {
		if (percent === 100) {
			return "green";
		}
		if (percent > 20) {
			return ""; // primary blue
		}
		return "amber";
	};

	return (
		<div className="crm-card crm-table-card crm-clients-table-card">
			<div className="crm-table-wrap">
				<table className="crm-table">
					<thead>
						<tr>
							<th>Mijoz</th>
							<th>Bino / Xona</th>
							<th>To'lov turi</th>
							<th>To'langan</th>
							<th>Qarz</th>
							<th>Menejer</th>
							<th aria-label="Actions" />
						</tr>
					</thead>
					<tbody>
						{clients.length === 0 ? (
							<tr>
								<td colSpan={7} style={{ textAlign: "center", padding: "30px 10px" }}>
									<span className="crm-user-role">Mijozlar topilmadi</span>
								</td>
							</tr>
						) : (
							clients.map((client) => (
								<tr key={client.id} onClick={() => onOpenClient(client)}>
									<td>
										<div className="crm-org-name-cell">
											<span className={`crm-mini-avatar ${client.tone || "blue"}`}>
												{client.initials}
											</span>
											<div>
												<strong>
													{[client.lastName, client.firstName, client.patronymic]
														.filter(Boolean)
														.join(" ")}
												</strong>
												<span>{client.phone}</span>
											</div>
										</div>
									</td>
									<td data-label="Bino / Xona">
										{client.buildingName} ·{" "}
										<strong className="font-bold">{client.roomNumber}</strong>
									</td>
									<td data-label="To'lov turi">
										<span
											className={`crm-badge ${client.paymentType === "naqd" ? "blue" : "amber"}`}
										>
											{client.paymentType === "naqd" ? "Naqd" : "Muddatli"}
										</span>
									</td>
									<td data-label="To'langan">
										<div className="crm-client-progress-wrap">
											<div className="crm-prog grow">
												<div
													className={`crm-prog-fill ${getProgressFillColor(client.paidPercent)}`}
													style={{ width: `${client.paidPercent}%` }}
												/>
											</div>
											<span className="font-bold" style={{ fontSize: "12px", width: "32px" }}>
												{client.paidPercent}%
											</span>
										</div>
									</td>
									<td data-label="Qarz">
										{client.debtCount > 0 ? (
											<span className="crm-badge red">{client.debtCount} ta qarz</span>
										) : (
											<span className="crm-user-role">—</span>
										)}
									</td>
									<td data-label="Menejer">
										<span style={{ fontSize: "12px" }}>{client.managerName}</span>
									</td>
									<td>
										<Button
											className="crm-open-btn"
											onClick={(event) => {
												event.stopPropagation();
												onOpenClient(client);
											}}
											size="small"
										>
											Karta <RightOutlined />
										</Button>
									</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>
			<div className="crm-table-foot">
				<span>Jami {clients.length} ta mijoz</span>
				<div className="crm-pager">
					<button type="button" disabled>
						‹
					</button>
					<button className="active" type="button">
						1
					</button>
					<button type="button" disabled>
						›
					</button>
				</div>
			</div>
		</div>
	);
}
